import classNames from 'classnames';
import { useMemo } from 'react';
import { breakpoints, useIsSmallerThan } from '~/components/Breakpoint/Breakpoint.hook';
import {
  LeaderboardGroup,
  Ranking,
  useChallengeLeaderboard,
} from '~/components/Challenge/Leaderboard/ChallengeLeaderboard.hooks';
import { ChallengeLeaderboardList } from '~/components/Challenge/Leaderboard/List/ChallengeLeaderboardList';
import { ChallengeLeaderboardTable } from '~/components/Challenge/Leaderboard/Table/ChallengeLeaderboardTable';
import { BaseError } from '~/components/Error/BaseError';
import styles from './ChallengeLeaderboard.module.scss';

export type ChallengeLeaderboardProps = {
  group: LeaderboardGroup;
  eventId?: number;
  className?: string;
};
export const ChallengeLeaderboard = ({ className, group, eventId }: ChallengeLeaderboardProps) => {
  const {
    data: { rankers, myRank },
    isFetching,
    isFetched,
    isPlaceholderData,
  } = useChallengeLeaderboard({ group, week: eventId }, { enabled: !!eventId });
  const items = useMemo(() => {
    if (group === 'TOP' || !isFetched) {
      return rankers;
    }

    const my = rankers.find(({ rank }) => rank === myRank);
    return [{ ...my, me: true }, ...rankers.filter((item) => item !== my)].filter(
      Boolean
    ) as (Ranking & {
      me?: boolean;
    })[];
  }, [group, myRank, rankers, isFetched]);

  const isMobile = useIsSmallerThan(breakpoints.medium);
  const Component = isMobile ? ChallengeLeaderboardList : ChallengeLeaderboardTable;

  if (isFetched && rankers.length === 0) {
    throw new BaseError('EMPTY');
  }

  return (
    <Component
      className={classNames(
        styles.root,
        styles[group],
        { [styles.loading]: isFetching, [styles.initial]: isPlaceholderData },
        className
      )}
      items={items}
    />
  );
};
